import React             from 'react'
import { Button, Table } from 'react-bootstrap'
import Confirm           from 'react-confirm-bootstrap'

import { isValidEmail  } from 'alto-utils/lib/utils'
import { SaveInput     } from 'alto-react-components/lib/components'

import './edit_user_table.sass'

export default class EditUserTable extends React.Component
  constructor: (props, context) ->
    super(props, context)

    @state =
      email: props.user.email
      activationEmail: null
      passwordResetEmail: null
      confirmDeleteCountdown: null

  render: ->
    <Table id='edit-user-table'>
      <tbody>
        {@usernameRow()}
        {@emailRow()}
        {@activationRow()}
        {@passwordResetRow()}
        {@staffRow()}
        {@deleteRow()}
      </tbody>
    </Table>

  usernameRow: ->
    <tr>
      <td>Přihlašovací jméno</td>
      <td>{@props.user.username}</td>
    </tr>

  emailRow: ->
    <tr>
      <td>Email</td>
      <td>
        <SaveInput value={@state.email}
                   help={@props.emailErrors?.join()}
                   isValid={not @props.emailErrors and isValidEmail(@state.email)}
                   isSaved={@state.email == @props.user.email}
                   onChange={@onEmailChange.bind(@)}
                   onSave={=> @props.updateEmail(@state.email)} />
      </td>
    </tr>

  onEmailChange: (email) ->
    @setState({ email })
    @props.clearEmailErrors()

  activationRow: ->
    isActive = @props.user.isActive

    caption =
      if      @state.activationEmail == 'sent'    then 'Odesláno'
      else if @state.activationEmail == 'sending' then 'Odesílám'
      else                                             'Odeslat aktivační email'

    onClick  = =>
      @setState(activationEmail: 'sending')

      @props.sendActivationEmail().then =>
        @setState(activationEmail: 'sent')

    <tr>
      <td>Webový účet {if isActive then 'je' else 'není'} aktivován</td>
      <td>
        <Button bsStyle='primary' onClick={onClick} disabled={isActive or @state.activationEmail?}>
          {caption}
        </Button>
      </td>
    </tr>

  passwordResetRow: ->
    caption =
      if      @state.passwordResetEmail == 'sent'    then 'Odesláno'
      else if @state.passwordResetEmail == 'sending' then 'Odesílám'
      else                                                'Odeslat'

    onClick = =>
      @setState(passwordResetEmail: 'sending')

      @props.sendPasswordResetEmail().then =>
        @setState(passwordResetEmail: 'sent')

    <tr>
      <td>Zaslání emailu pro reset hesla</td>
      <td>
        <Button bsStyle='primary' onClick={onClick} disabled={@state.passwordResetEmail?}>
          {caption}
        </Button>
      </td>
    </tr>

  staffRow: ->
    isStaff = @props.user.isStaff

    <tr>
      <td>Webový účet {if isStaff then 'má' else 'nemá'} zaměstnanecká práva</td>
      <td>
        <Button bsStyle={if isStaff then 'danger' else 'primary'} onClick={@props.toggleStaff}>
          {if isStaff then 'Odebrat' else 'Přidat'}
        </Button>
      </td>
    </tr>

  deleteRow: ->
    caption =
      if @state.confirmDeleteCountdown?
        if @state.confirmDeleteCountdown > 0
          "Opravdu? (#{@state.confirmDeleteCountdown})"
        else
          'Opravdu!'
      else
        'Smazat účet'

    onClick = =>
      tickInterval = 500

      tick = =>
        countdown = @state.confirmDeleteCountdown

        if countdown > 0
          @setState(confirmDeleteCountdown: countdown - 1)
          setTimeout(tick, tickInterval)

      if @state.confirmDeleteCountdown == 0
        @props.deleteUser()
      else
        @setState(confirmDeleteCountdown: 3)
        setTimeout(tick, tickInterval)

    <tr>
      <td>Trvalé smazání webového účtu</td>
      <td>
        <Button bsStyle='danger' onClick={onClick}
                disabled={@state.confirmDeleteCountdown? and @state.confirmDeleteCountdown > 0}>
          {caption}
        </Button>
      </td>
    </tr>
